import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/global-error.tsx")